var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 7H15.55V20H16.25C16.8299 20 17.3 20.485 17.3 21.0833C17.3 21.6816 16.8299 22.1667 16.25 22.1667H12.75C12.1701 22.1667 11.7 21.6816 11.7 21.0833C11.7 20.485 12.1701 20 12.75 20H13.45V7H9.6V8.08348C9.6 8.68179 9.1299 9.16682 8.55 9.16682C7.9701 9.16682 7.5 8.68179 7.5 8.08348V5.91667C7.5 5.31836 7.9701 4.83333 8.55 4.83333H20.45C21.0299 4.83333 21.5 5.31836 21.5 5.91667V8.08348C21.5 8.68179 21.0299 9.16682 20.45 9.16682C19.8701 9.16682 19.4 8.68179 19.4 8.08348V7ZM5.75 0.5C2.8505 0.5 0.5 2.92512 0.5 5.91667V21.0833C0.5 24.0749 2.85051 26.5 5.75 26.5H23.25C26.1495 26.5 28.5 24.0749 28.5 21.0833V5.91667C28.5 2.92512 26.1495 0.5 23.25 0.5H5.75ZM2.6 5.91667C2.6 4.12174 4.0103 2.66667 5.75 2.66667H23.25C24.9897 2.66667 26.4 4.12174 26.4 5.91667V21.0833C26.4 22.8783 24.9897 24.3333 23.25 24.3333H5.75C4.0103 24.3333 2.6 22.8783 2.6 21.0833V5.91667Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBox);
export default __webpack_public_path__ + "static/media/text-box.9a36c2c3928fd929b634dcd43a684abd.svg";
export { ForwardRef as ReactComponent };